import { GetterTree, Module } from "vuex";

import DesktopConfig from "./types/desktop-app.config-class";
import { IDesktopStore } from "./types/desktop-app.types";
import { RootState } from "../store";

const state: IDesktopStore = {
  config: new DesktopConfig()
};

const getters: GetterTree<IDesktopStore, RootState> = {
  config: (state: IDesktopStore) => state.config
};

export const desktopStore: Module<IDesktopStore, RootState> = {
  getters,
  state
};
